<template>
    <div class="w-100">
        <RatingModal
            :uid="$route.query.uid as string"
            :feedback-hash="$route.query.feedbackHash as string"
            :object-id="$route.query.objectId as string"
            :type="$route.query.type as string"
            :email-rating="parseInt($route.query.rating as string)"
        />
        <Banners v-if="!banners?.length && bannerList" :banners="bannerList.banner" :show-arrows="true" />

        <!--        <div class="container">-->
        <!--            <div class="productCarousel mt-0">-->
        <!--                <h1 class="h2 my-3 mt-3 mt-md-4">{{ bannersTitle ? bannersTitle : $t('carouselHomepage.defaultBannersTitle') }}</h1>-->
        <!--            </div>-->
        <!--        </div>-->

        <ElementsHomepageBanners
            :banners="upperBanners"
            :carousel-banners="upperCarouselBanners"
            matomo-banner-category="Homepage Banner"
        />

        <div class="container">
            <div class="productCarousel">
                <ElementsBannersTopCategory :banners="banners.slice(0, 3)" matomo-banner-category="Homepage Banner" :small="true" />
            </div>

            <div v-if="topicBanners?.length" class="productCarousel">
                <ElementsTopicBanners :banners="topicBanners.slice(0, 8)" />
            </div>

            <!--            <SkeletonProductCarouselSkeleton v-if="historyProductList === null" :max-number-of-products="6" />-->
            <!--            <div v-else-if="historyProductList.length > 0 && false" class="productCarousel">-->
            <!--                <CarouselBox-->
            <!--                    :title="$t('carouselHomepage.recentlyPurchasedProducts')"-->
            <!--                    :products="historyProductList"-->
            <!--                    class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    :item-list-name="recentlyPurchasedItemListName"-->
            <!--                />-->
            <!--            </div>-->

            <!--            <SkeletonProductCarouselSkeleton v-if="favoriteProducts === null" :max-number-of-products="6" />-->
            <!--            <div v-else-if="favoriteProducts.length > 0 && false" class="productCarousel">-->
            <!--                <CarouselBox-->
            <!--                    :title="$t('carouselHomepage.wishlistProducts')"-->
            <!--                    :products="favoriteProducts"-->
            <!--                    class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    :item-list-name="favoriteProductsItemListName"-->
            <!--                    :refresh-frequently-actualized-data="true"-->
            <!--                />-->
            <!--            </div>-->

            <!--            <DelayHydration>-->
            <!--                <ProductTabs-->
            <!--                    :title="$t('carouselHomepage.title')"-->
            <!--                    :tabs="selectedProducts"-->
            <!--                    :item-list-name="pilulkaSelectsItemListName"-->
            <!--                    :lazy="false"-->
            <!--                    :show-pharmacy-price="false"-->
            <!--                    class="mt-4"-->
            <!--                />-->
            <!--            </DelayHydration>-->

            <DelayHydration>
                <ElementsCustomHomepageAddonSaleCarousels :carousels="customHomepageAddonSaleCarousels" />
            </DelayHydration>

            <BrandsBox :brands="brandLogos" />

            <SkeletonProductCarouselSkeleton v-if="lastBoughtRecommendedProducts === null" :max-number-of-products="6" />
            <div v-else-if="lastBoughtRecommendedProducts.length > 0" class="productCarousel">
                <CarouselBox
                    :title="$t('carouselHomepage.lastBoughtRecommendedProducts')"
                    :products="lastBoughtRecommendedProducts"
                    class="carouselBox--fullWidth"
                    :item-list-name="lastBoughtRecommendedProductsItemListName"
                    :refresh-frequently-actualized-data="true"
                />
            </div>

            <DailyOffer v-if="dailyDeal" :product="dailyDeal.product" :banner="{}" />

            <!--            <DelayHydration>-->
            <!--                <SalesAndDiscountsCarousel :products="actionsAndSalesProducts" />-->
            <!--            </DelayHydration>-->

            <!--            <DelayHydration>-->
            <!--                <div v-if="onePlusOneProducts?.length > 5" class="productCarousel">-->
            <!--                    <CarouselBox-->
            <!--                        :title="$t('carouselHomepage.onePlusOneProducts')"-->
            <!--                        :url="$t('header.url.category.onePlusOne')"-->
            <!--                        :products="onePlusOneProducts"-->
            <!--                        :item-list-name="onePlusOneProductsItemListName"-->
            <!--                        class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    />-->
            <!--                </div>-->
            <!--            </DelayHydration>-->

            <!--            <DelayHydration>-->
            <!--                <div v-if="twoPlusOneProducts?.length > 5" class="productCarousel">-->
            <!--                    <CarouselBox-->
            <!--                        :title="$t('carouselHomepage.twoPlusOneProducts')"-->
            <!--                        :url="$t('header.url.category.twoPlusOne')"-->
            <!--                        :products="twoPlusOneProducts"-->
            <!--                        :item-list-name="twoPlusOneProductsItemListName"-->
            <!--                        class="carouselBox&#45;&#45;fullWidth"-->
            <!--                    />-->
            <!--                </div>-->
            <!--            </DelayHydration>-->

            <CarouselById
                v-if="isUserAuthenticated"
                :ids="lastViewProducts"
                :title="$t('carouselHomepage.lastViewProducts')"
                :class-carousel="'productCarousel--home'"
                :class-name="'carouselBox--fullWidth'"
                :available-only="true"
                :item-list-name="lastViewedProductsItemListName"
            />

            <!--            <BenefitBoxes v-if="!isChristmasSeason" class="benefitBoxes&#45;&#45;top my-3" />-->
            <!--            <ChristmasUspBoxes v-else class="benefitBoxes&#45;&#45;top" />-->

            <MobileAppBanner />

            <!--            <HomepageStaticBanners :banner-list="servicesStaticBanners[locale] || []" />-->

            <ArticlesWidget :articles="articles" />

            <HomepageStaticBanners :banner-list="upperStaticBanners[locale] || []" />

            <HomepageStaticBanners :banner-list="lowerStaticBanners[locale] || []" />
        </div>

        <Head>
            <Title>{{ $t('homepageTitle') }}</Title>
            <Link v-if="preloadedBannerUrl" rel="preload" as="image" :href="preloadedBannerUrl" fetchpriority="high" />
            <Link rel="canonical" :href="$config.public.apiUrl" />
            <Meta name="description" :content="$t('metaDescription')" />
            <Body data-no-cache="true" />
            <!-- TODO Delete this after productCard test -->
        </Head>
    </div>
</template>

<script lang="ts">
// @ts-nocheck

import { Context } from '@nuxt/types'
import { useI18n } from 'vue-i18n'
import DataLayer from '../extensions/DataLayer'
import BenefitBoxes from '~/components/objects/BenefitBoxes.vue'
import RatingModal from '~/components/elements/RatingModal.vue'
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'
import DailyOffer from '~/components/objects/DailyOffer.vue'
import ProductTabs from '~/components/elements/ProductTabs.vue'
import Banners from '~/components/objects/Banners.vue'
import CarouselBox from '~/components/elements/CarouselBox.vue'
import BrandsBox from '~/components/layout/home/BrandsBox.vue'
import CarouselById from '~/components/elements/CarouselById.vue'
import { useCookie, useUidCookie } from '#imports'
import { useLayoutStore } from '~/stores/layout'
import SalesAndDiscountsCarousel from '~/components/elements/SalesAndDiscountsCarousel.vue'
import GtmPageData from '~/models/DataLayer/GtmPageData'
import useCommonStructuredData from '~/composables/useCommonStructuredData'
import { useBasketStore } from '~/stores/basket'
import useApiResponseCache from '~/composables/useApiResponseCache'
import PWAHomepage from '~/models/Api/PWAHomepage'
import { minimizeProductArray } from '~/utils/minimizeProductArray'
import HomepageStaticBanners from '~/components/layout/home/HomepageStaticBanners.vue'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import MobileAppBanner from '~/components/layout/home/MobileAppBanner.vue'
import ArticlesWidget from '~/components/layout/home/ArticlesWidget.vue'
import ChristmasUspBoxes from '~/components/objects/ChristmasUspBoxes.vue'
import { usePerformanceStore } from '~/stores/performace'
import Product from '~/models/Product/Product'
import { useAuthStore } from '~/stores/auth'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import Article from '~/models/StaticContent/Article/Article'
import Banner from '~/models/components/Banner'
import BannerTopCategory from '~/models/BannerTopCategory'
import TopicBanner from '~/models/Banners/TopicBanner'

export default defineNuxtComponent({
    components: {
        ChristmasUspBoxes,
        ArticlesWidget,
        HomepageStaticBanners,
        SalesAndDiscountsCarousel,
        LazyLoadComponent,
        DailyOffer,
        ProductTabs,
        BenefitBoxes,
        Banners,
        CarouselBox,
        BrandsBox,
        CarouselById,
        RatingModal,
        MobileAppBanner,
    },
    scrollToTop: true,
    props: {
        closestOfficeDisplayType: {
            type: String,
            default: 'short',
        },
        saleProducts: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            customHomepageAddonSaleCarousels: [] as { position: string; products: Product[]; title: string; titleLink: string }[],
            historyProductList: [] as Product[],
            favoriteProducts: [] as Product[],
            lastBoughtRecommendedProducts: [] as Product[],
            haveAccess: useAccessTokenCookie().value || false,
            bannerList: {
                total: 0,
                banner: [],
            } as {
                total: number
                banner: Banner[]
            },
            selectedProducts: [] as { name: string; products: Product[] }[],
            dailyDeal: null as { product: Product } | null,
            actionsAndSalesProducts: [] as Product[],
            onePlusOneProducts: [] as Product[],
            twoPlusOneProducts: [] as Product[],
            articles: [] as Article[],
            brandLogos: [],
            banners: [] as BannerTopCategory[],
            upperBanners: [] as BannerTopCategory[],
            upperCarouselBanners: [] as BannerTopCategory[],
            bannersTitle: null,
            upperStaticBanners: {
                sk: [
                    // {
                    //     mobileImage: '/nuxt-assets/images/banners/pilulka-expres.jpg?v=2',
                    //     desktopImage: '/nuxt-assets/images/banners/pilulka-expres-x2.jpg?v=2',
                    //     alt: 'Pilulka Expres',
                    //     url: '/pilulka-auto',
                    // },
                    // {
                    //     mobileImage: '/nuxt-assets/images/banners/pilulka-box.jpg',
                    //     desktopImage: '/nuxt-assets/images/banners/pilulka-box-x2.jpg',
                    //     alt: 'Pilulka Box',
                    //     url: '/pilulka-box',
                    // },
                ],
                cs: [
                    // {
                    //     mobileImage: '/nuxt-assets/images/cs/banners/pilulka-expres.jpg?v=1',
                    //     desktopImage: '/nuxt-assets/images/cs/banners/pilulka-expres-x2.jpg?v=1',
                    //     alt: 'Pilulka Expres',
                    //     url: '/pilulka-expres',
                    // },
                    // {
                    //     mobileImage: '/nuxt-assets/images/cs/banners/pilulka-box.jpg?v=1',
                    //     desktopImage: '/nuxt-assets/images/cs/banners/pilulka-box-x2.jpg?v=1',
                    //     alt: 'Pilulka Box',
                    //     url: '/pilulka-box',
                    // },
                ],
            },
            lowerStaticBanners: {
                cs: [
                    // {
                    //     mobileImage: '/nuxt-assets/images/cs/banners/pilulka-zivotozpravy.jpg?v=1',
                    //     desktopImage: '/nuxt-assets/images/cs/banners/pilulka-zivotozpravy-x2.jpg?v=1',
                    //     alt: 'Podcast',
                    //     url: '/zivotozpravy',
                    // },
                    // {
                    //     mobileImage: '/nuxt-assets/images/cs/banners/pilulka-nedoklubko.jpg?v=1',
                    //     desktopImage: '/nuxt-assets/images/cs/banners/pilulka-nedoklubko-x2.jpg?v=1',
                    //     alt: 'Nedoklubko',
                    //     url: '/pilulka-pomaha',
                    // },
                ],
                sk: [],
                //     {
                //         mobileImage: '/nuxt-assets/images/sk/banners/pilulka-zivotozpravy.jpg?v=1',
                //         desktopImage: '/nuxt-assets/images/sk/banners/pilulka-zivotozpravy-x2.jpg?v=1',
                //         alt: 'Podcast',
                //         url: '/zivotozpravy',
                //     },
                //     {
                //         mobileImage: '/nuxt-assets/images/sk/banners/pilulka-nedoklubko.png?v=1',
                //         desktopImage: '/nuxt-assets/images/sk/banners/pilulka-nedoklubko-x2.png?v=1',
                //         alt: 'Nedoklubko',
                //         url: '/pilulka-pomaha',
                //     },
                // ],
            },
            lastViewProducts: [] as number[],
            servicesStaticBanners: {
                cs: [
                    {
                        mobileImage: '/nuxt-assets/images/cs/banners/poradna.png',
                        desktopImage: '/nuxt-assets/images/cs/banners/poradna.png',
                        alt: 'Poradna',
                        url: '/poradna',
                    },
                    {
                        mobileImage: '/nuxt-assets/images/cs/banners/pilulka-lekarny.png',
                        desktopImage: '/nuxt-assets/images/cs/banners/pilulka-lekarny.png',
                        alt: 'Pilulka Lékárny',
                        url: '/pilulka-lekarny',
                    },
                ],
                sk: [],
            },
            topicBanners: [] as TopicBanner[],
        }
    },

    watchQuery: ['pwa'],

    fetchKey: 'homepage',

    async asyncData({ $repository }: Context): Promise<object> {
        const authStore = useAuthStore()
        const accessToken = authStore.accessToken
        const uid = useBasketStore().uid
        const homepagePromise = useApiResponseCache<PWAHomepage>(
            '/api/v2/pwa/homepage',
            600,
            async () => {
                const performanceStore = usePerformanceStore()
                const start = performance.now()
                const responseToReturn = [
                    'customHomepageAddonSaleCarousels',
                    'essentials',
                    'selectedProducts',
                    'saleProducts',
                    'dailyDeal',
                    'banners',
                    'upperBanners',
                    'upperCarouselBanners',
                    'topicBanners',
                ]
                responseToReturn.push('historyProductList', 'favoriteProducts')
                const response: PWAHomepage = await $repository.getPWAHomepageData({
                    accessToken,
                    response: responseToReturn,
                    uid,
                })
                performanceStore.add('api', performance.now() - start)

                try {
                    response.actionsAndSalesProducts = minimizeProductArray(response.actionsAndSalesProducts)
                } catch (e) {
                    console.log('actionsAndSalesProducts error', e)
                }

                try {
                    response.customHomepageAddonSaleCarousels = response.customHomepageAddonSaleCarousels.map((carousel) => {
                        carousel.products = minimizeProductArray(carousel.products)

                        return carousel
                    })
                } catch (e) {
                    console.log('customHomepageAddonSaleCarousels error', e)
                }

                try {
                    response.selectedProducts = response.selectedProducts.map((carousel) => {
                        carousel.products = minimizeProductArray(carousel.products)

                        return carousel
                    })
                } catch (e) {
                    console.log('selectedProducts error', e)
                }

                try {
                    response.favoriteProducts = minimizeProductArray(response.favoriteProducts)
                } catch (e) {
                    console.log('favoriteProducts error', e)
                }

                try {
                    response.historyProductList = {
                        products: response.historyProductList === null ? [] : minimizeProductArray(response.historyProductList.products),
                    }
                } catch (e) {
                    console.log('historyProductList error', e)
                }

                try {
                    response.onePlusOneProducts = minimizeProductArray(response.onePlusOneProducts)
                } catch (e) {
                    console.log('onePlusOneProducts error', e)
                }

                try {
                    response.twoPlusOneProducts = minimizeProductArray(response.twoPlusOneProducts)
                } catch (e) {
                    console.log('twoPlusOneProducts error', e)
                }

                return response
            },
            !accessToken // use cache only if accessToken is null or empty string
        )

        const lastBoughtRecommendedProductsPromise = accessToken
            ? $repository.listLastBoughtRecommendedProducts({ accessToken, uid: useUidCookie().value || '' })
            : Promise.resolve({ response: { products: [] } })

        const [response, lastBoughtRecommendedProductsResponse] = await Promise.all([homepagePromise, lastBoughtRecommendedProductsPromise])

        return {
            dailyDeal: response.dailyDeal,
            selectedProducts: response.selectedProducts,
            brandLogos: response.brandLogos,
            customHomepageAddonSaleCarousels: response.customHomepageAddonSaleCarousels,
            bannerList: response.bannerList,
            structuredData: response.structuredData,
            actionsAndSalesProducts: response.actionsAndSalesProducts,
            articles: response.articles,
            favoriteProducts: response.favoriteProducts,
            historyProductList: response.historyProductList?.products || [],
            onePlusOneProducts: response.onePlusOneProducts,
            twoPlusOneProducts: response.twoPlusOneProducts,
            lastBoughtRecommendedProducts: lastBoughtRecommendedProductsResponse.response.products || [],
            banners: response.banners,
            upperBanners: response.upperBanners,
            upperCarouselBanners: response.upperCarouselBanners,
            bannersTitle: response.bannersTitle,
            topicBanners: response.topicBanners,
        }
    },

    computed: {
        locale(): 'cs' | 'sk' {
            const i18n = useI18n()

            return i18n.t('locale') as 'cs' | 'sk'
        },

        onePlusOneProductsItemListName(): string {
            return GtmItemListNameEnum.HPOnePlusOneCarousel
        },

        twoPlusOneProductsItemListName(): string {
            return GtmItemListNameEnum.HPTwoPlusOneCarousel
        },

        lastViewedProductsItemListName(): string {
            return GtmItemListNameEnum.HPLastVisited
        },

        recentlyPurchasedItemListName(): string {
            return GtmItemListNameEnum.HPPreviouslyPurchased
        },

        lastBoughtRecommendedProductsItemListName(): string {
            return GtmItemListNameEnum.HPLastBoughtRecommendedProducts
        },

        favoriteProductsItemListName(): string {
            return GtmItemListNameEnum.HPFavoriteProducts
        },

        pilulkaSelectsItemListName(): string {
            return GtmItemListNameEnum.HPPilulkaSelects
        },

        preloadedBannerUrl(): string | null {
            if (this.bannerList && this.bannerList.banner && this.bannerList.banner.length) {
                return this.$device.isDesktop ? this.bannerList.banner[0].desktopImage : this.bannerList.banner[0].mobileImage
            }

            return null
        },

        isUserAuthenticated(): boolean {
            return this.authUser !== null
        },

        authUser(): object | null {
            const basketStore = useBasketStore()

            return basketStore.authUser
        },

        isChristmasSeason(): boolean {
            const date = new Date()
            const currentDate = date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()

            return currentDate < this.$config.public.xmasDelivery
        },
    },

    mounted(): void {
        // setTimeout(() => {
        //     this.loadUserSpecificData()
        // })

        const layoutStore = useLayoutStore()
        layoutStore.setStructuredData(this.structuredData)

        const page = {
            type: 'homepage',
            title: this.$t('metaDescription'),
        } as GtmPageData

        DataLayer.pushPageViewToDataLayer(page)

        const idProducts = useCookie<number[]>('lastViewProductsIds').value
        this.lastViewProducts = idProducts && idProducts.length > 2 ? idProducts : []

        this.initLuigisBoxEvents()
    },

    methods: {
        initLuigisBoxEvents() {
            LuigisBoxEventApi.sendPageView()
        },

        async loadUserSpecificData() {
            const accessToken = useAccessTokenCookie().value
            if (!accessToken) {
                this.favoriteProducts = []
                this.historyProductList = []

                return
            }

            const responseToReturn = ['historyProductList', 'favoriteProducts']

            const response: PWAHomepage = await this.$repository.getPWAHomepageData({ accessToken, response: responseToReturn })

            try {
                this.favoriteProducts = response.favoriteProducts
            } catch (e) {
                this.favoriteProducts = []
                console.log('favoriteProducts error', e)
            }

            try {
                this.historyProductList = response.historyProductList?.products || []
            } catch (e) {
                this.historyProductList = []
                console.log('historyProductList error', e)
            }
        },
    },

    jsonld() {
        const commonStructuredData = useCommonStructuredData({
            config: this.$config,
            i18nTranslate: this.$t,
            breadcrumbsItems: [],
            addSearchAction: true,
        })

        const product = {
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@type': 'Product',
                    name: this.structuredData?.name,
                    aggregateRating: {
                        '@type': 'AggregateRating',
                        ratingValue: this.structuredData?.rating,
                        reviewCount: this.structuredData?.reviews,
                    },
                    offers: {
                        '@type': 'AggregateOffer',
                        lowPrice: this.structuredData?.aggregateOffer.minPrice,
                        priceCurrency: this.$t('currency'),
                        highPrice: this.structuredData?.aggregateOffer.maxPrice,
                    },
                },
            ],
        }

        return [...commonStructuredData, product]
    },
})
</script>

<style lang="scss" scoped>
h2 {
    font-size: 24px;
}
</style>
<style lang="scss" scoped>
.productCarousel {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 1em auto 0em;
}
</style>
